module.exports = __webpack_public_path__ + "static/step-1-f71ea118207d9cd7ffe82ce29b1fd5f5.jpg";